/** Skupno za Nastavitve → Urejanje slik in urejanje slike pri vozilu. */
export type VrstaOzadja = 'NESPREMENJENO' | 'STUDIO' | 'LASTNO';

export const KLJUC_UREJANJA_SLIK = ['urejanje-slik'];

export const VRSTE_OZADJA: { value: VrstaOzadja; label: string }[] = [
  { value: 'NESPREMENJENO', label: 'Nespremenjeno' },
  { value: 'STUDIO', label: 'Studio' },
  { value: 'LASTNO', label: 'Lastno ozadje' },
];
